<template>
    <v-card raised class="mb-4">
        <v-layout row wrap>
        <v-flex xs12 md6>
            <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
              <v-flex d-flex xs8>{{recentReg.Facility}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Date')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Date")}}:</v-flex>
              <v-flex d-flex xs8>{{getDate(recentReg.CreatedDate)}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.ArticleNo}} - {{recentReg.ArticleName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.CarrierNo}} - {{recentReg.CarrierName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(recentReg)}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Delivered')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Unloaded amount")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.RegDelivered}}</v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 md6>
            <v-layout v-if="!isHide('Fuel type')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Fuel type")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.WasteFuelTypeNo}} - {{recentReg.WasteFuelTypeName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.AgreementNo}} - {{recentReg.AgreementName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.DeliveryNo}} - {{recentReg.DeliveryName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Delivered')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Amount")}}:</v-flex>
              <v-flex d-flex xs8>{{recentReg.Amount}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('RegistrationNo')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
              <v-flex d-flex xs8>{{recentReg.ScanXRegNo}}</v-flex>
            </v-layout>
        </v-flex>
        </v-layout>
        <!-- <v-divider></v-divider> -->
        <v-card-actions style="padding: 0px 0px 0px 0px" v-if="recentReg.RegistrationId === '00000000-0000-0000-0000-000000000000'">
            <v-flex xs12 class="mb-4">
              <v-layout row wrap>
                <v-flex grow></v-flex>
                <v-btn class="mt-1 mr-3 mb-n1" @click="cancelRegistration(recentReg)" color="primary" >
                  {{$t("Cancel")}}
                </v-btn>
              </v-layout>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
import * as Security from '@/core/security'
import * as UnloadingFuel from '@/modules/unloading-fuel/unloading-fuel'
import * as DateUtil from '@/core/date'

export default {
  props: ['recentReg'],
  data () {
    return {
      hiddenFields: [],
      cancelTimer: null
    }
  },
  methods: {
    getCustomerStr (recentReg) {
      if (recentReg.CustomerNo && recentReg.CustomerName) { return recentReg.CustomerNo + ' - ' + recentReg.CustomerName } else if (recentReg.CustomerNo) { return recentReg.CustomerNo } else if (recentReg.CustomerName) { return recentReg.CustomerName } else { return '' }
    },
    getWeightStr (recentReg) {
      return Math.abs(recentReg.WeightNet) + ' kg'
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    getDate (date) {
      return DateUtil.getDateTime(date)
    },
    async cancelRegistration (recentReg) {
      if (this.recentReg.RegistrationId === '00000000-0000-0000-0000-000000000000') {
        const res = await UnloadingFuel.loadActiveRegistration(this.recentReg.Id)
        if (!res.failed) {
          this.recentReg.RegistrationId = res.data.RegistrationId
          this.recentReg.ScanXRegNo = res.data.ScanXRegNo
        }
      }
      if (this.recentReg.RegistrationId !== '00000000-0000-0000-0000-000000000000') {
        this.$root.$message.showError(this.$t('This registration can not be canceled any more'))
        return
      }

      this.loading = true
      const res = UnloadingFuel.CancelRegistration(recentReg.Id)
      if (!res.failed) {
        this.registrations = res.data

        this.$root.$emit('msgloadUnloadingFuels')
      }

      this.loading = false
    }
  },
  beforeDestroy () {
    // Stop Cancel timer
    if (this.cancelTimer) clearInterval(this.cancelTimer)
  },
  async mounted () {
    // Check if Cancel button must be shown every 5 sec
    if (this.recentReg.RegistrationId === '00000000-0000-0000-0000-000000000000') {
      this.cancelTimer = setInterval(async () => {
        if (this.recentReg.RegistrationId === '00000000-0000-0000-0000-000000000000') {
          const res = await UnloadingFuel.loadActiveRegistration(this.recentReg.Id)
          if (!res.failed) {
            this.recentReg.RegistrationId = res.data.RegistrationId
            this.recentReg.ScanXRegNo = res.data.ScanXRegNo
          }
        }
      }, 5000) // timer run every 5 sec
    }

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      // const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      const defaultHidden = 'RequisitionNo2,Plant,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'recentRegistration_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }
  }

}
</script>
